/* core */
import React from 'react';
/* third-party */
import CircularProgress from '@material-ui/core/CircularProgress';

export const PageLoader = () => {
  return (
    <div>
      <CircularProgress />
    </div>
  );
};
